import { useQuery } from '@apollo/client';
import { useEntity } from '@avangard/utils/entity';

import { ChatEntityList } from '@modules/chat/entities';
import { GetChatsQuery } from '@modules/chat/graphql';

import type { QueryHookOptions } from '@apollo/client';
import type { GetChatsQueryType, GetChatsQueryVariables } from '@modules/types/graphql';

const useChats = (options: QueryHookOptions<GetChatsQueryType, GetChatsQueryVariables> = {}) => {
    const queryResult = useQuery<GetChatsQueryType, GetChatsQueryVariables>(GetChatsQuery, options);

    const { entities: chats, count } = useEntity(
        () => new ChatEntityList(queryResult.data?.getChats ?? null),
        [queryResult.data],
    );

    const result = {
        chats,
        count,
        ...queryResult,
    };

    return result;
};

export { useChats };
